import { getLocaleValue } from '@/js/helper/locale.ts';
import ModalContainer from '@/js/vue/modal/modal-container.vue';
import ProductAvailableModalContent from '@/js/vue/modal/product-available-modal-content.vue';
import { createApp } from 'vue';

const div = document.createElement('div');
document.body.appendChild(div);

const app = createApp(ModalContainer, {}).mount(div);

/* eslint-disable ts/no-unsafe-assignment, ts/no-unsafe-call */
export function showModal({ component, props, onClose, containerClass, title }: any) {
  app.add(component, props, {
    onClose,
    containerClass,
    title,
  });
}
/* eslint-enable ts/no-unsafe-assignment, ts/no-unsafe-call */

export function showProductAvailableModal(
  name: string,
  image: string,
  price: string,
  productId: string,
) {
  showModal({
    title: getLocaleValue('notify_available'),
    component: ProductAvailableModalContent,
    props: {
      name,
      image,
      price,
      productId,
    },
  });
}
